import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { SdModalService, SdvorIconComponent } from '@sdvor/shared/ui/v2';
import { DeviceService } from '@shared/services';
import { IconTypes } from '@shared/v2';
import { CartClearConfirmationComponent } from '../../cart-clear-confirmation';

@Component({
  selector: 'sd-cart-action-clear',
  imports: [SdvorIconComponent],
  templateUrl: './cart-action-clear.component.html',
  styleUrls: ['./cart-action-clear.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CartActionClearComponent {
  private deviceService = inject(DeviceService);
  private modalService = inject(SdModalService);

  protected readonly isTabletMdDown = toSignal(this.deviceService.isTabletMdDown$, { initialValue: false });
  protected readonly iconTypes = IconTypes;

  protected onOpenClearModal(): void {
    this.modalService.open(CartClearConfirmationComponent, {
      modalType: { xxs: 'compact', md: 'standard' },
      maxWidth: { md: '435px' },
    });
  }
}
